import styled from '@emotion/styled'
export const StyleFooter = styled.div`
  padding: 15px 15px;
  background: ${(props: any) => props.theme.colors.white};
`
export const StyleMessageInputColumn = styled.div`
  position: relative;
  background: transparent;
  border-radius: 8px;
  padding: 5px 15px;
  border: 1px solid ${(props: any) => props.theme.colors.inputBorder};
`
export const StyleMessageInputWrapper = styled.div`
  display: flex;
`
export const StyleMessageInput = styled.input`
  width: 100%;
  background: transparent;
  border: 0px;
  padding-right: 100px;
  height: 40px;
  outline: none;
  &::placeholder {
    font-size: 12px;
  }
`

export const StyleMessageActionsRow = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`

export const StyleFilesWrapper = styled.div`
  display: flex;
  overflow-x: auto;
  column-gap: 10px;
`

export const StyleImageWrapper = styled.div`
  position: relative;
`
export const StyleImage = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 4px;
`
export const StyleFileWrapper = styled.div`
  position: relative;
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 4px;
  padding: 5px 10px;
  width: 120px;
  height: 50px;
  align-items: center;
  display: flex;
  column-gap: 5px;
`

export const StyleRemoveFile = styled.button`
  background: ${(props: any) => props.theme.colors.danger};
  border: 0px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0px;
  right: -7px;
`
